/* eslint-disable */
<template>
  <v-container>
    <v-layout>
      <v-flex  class="text-xs-center pb-3">
        <h1>Tell Us a Little About Your Lab</h1>
      </v-flex>
    </v-layout>

    <v-layout row v-if="userIsAuthenticated">

      <v-flex xs8 offset-xs2>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="addNewLab">
                <v-layout row>
                  <v-flex xs10 offset-xs1>
                    <v-text-field
                      name="name"
                      label="Name of your laboratory"
                      id="name"
                      v-model="name"
                      ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs10 offset-xs1>
                    <v-text-field
                      name="position"
                      label="What position are you trying to fill?"
                      id="position"
                      v-model="position"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs10 offset-xs1>
                    <v-text-field
                      name="imgURL"
                      label="Image URL"
                      id="imgURL"
                      v-model="imgURL"
                      ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs10 offset-xs1>
                    <v-textarea
                    name="description"
                    label="Brief description of your lab and open position"
                    id="description"
                    multi-line
                    v-model="description"
                    hint="Provide a brif description of your lab and the requirements of the position."
                    required></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 class="text-xs-center pt-4">
                    <v-btn
                      class="primary"
                      large
                      type="submit">Submit
                    </v-btn>
                  </v-flex>
                </v-layout>

              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      description: '',
      position: '',
      imgURL: ''
    }
  },
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  },
  methods: {
    addNewLab () {
      const newLab = {
        name: this.name,
        description: this.description,
        imgURL: this.imgURL,
        position: this.position
      }
      this.$store.dispatch('addNewLab', newLab)
      this.$router.push('/')
    }
  }
}
</script>
